import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MaaledataPeriodePage } from "@/features/maaledata/periode/MaaledataPeriodePage";

/**
 * Represents the search parameters for a monthly period.
 *
 * @property {number} month - The month for the search period (1-12).
 * @property {number} year - The year for the search period (e.g., 2024)
 */
export type MonthlyPeriodSearchParam = z.infer<
  typeof monthlyPeriodSearchParamSchema
>;

const monthlyPeriodSearchParamSchema = z.object({
  month: z.number().min(1).max(12).catch(1),
  year: z.number().min(1).catch(1),
});

export const Route = createFileRoute("/_app/_subheader/maalerdata/periode")({
  component: MaaledataPeriodePage,
  validateSearch: (search: Record<string, unknown>): MonthlyPeriodSearchParam =>
    monthlyPeriodSearchParamSchema.parse(search),
});
